// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Quicksand-VariableFont_wght.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Quicksand-VariableFont_wght.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Quicksand";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

:root {
  --accent-color: #2da0ff;
}

/* General styling */
body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  font-family: Quicksand, Arial, Helvetica, sans-serif;
}

body > * {
  width: 100%;
  max-width: 1600px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

header,
footer {
  flex: 0;
  height: 72px;
}

main {
  flex: 1;
}

section {
  flex: 1;
}

img {
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
}

nav ul {
  display: flex;
  list-style: none;
  gap: 24px;
}

svg {
  display: block;
  fill: #000;
  height: 36px;
  cursor: pointer;
}

p {
  max-width: 60ch;
}

h2 {
  font-size: 2.3rem;
  font-weight: 600;
}

h3 {
  font-weight: 500;
}

/* HEADER */
header {
  position: relative;
  div {
    position: relative;
    z-index: 1;
  }
}

.img-wrapper img {
  max-width: 350px;
}
.header-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  clip-path: polygon(0% 0%, 100% 0%, 100% 25%, 0% 50%);
  background-color: var(--accent-color);
}

.about-me {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
}

header p {
  margin: 8px 0 16px;
  font-size: 1.2rem;
}

header div {
  position: relative;
  margin-bottom: 18px;
  h1 {
    color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: fit-content;
    font-size: 3rem;
  }
}

/* MAIN */
main section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 56px 0 112px;
  h2 {
    margin-bottom: 24px;
    font-size: 3rem;
    font-weight: normal;
  }
}

.project-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 56px;
}

.project {
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 450px;
  max-width: 300px;
  box-shadow: 4px 4px 5px #d3d3d3;

  .screenshot {
    height: 275px;
    color: white;
    display: flex;
    align-items: center;
    font-size: 3rem;
  }

  .row {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  nav ul {
    gap: 8px;

    svg {
      height: 28px;
    }
  }

  p {
    margin: 0 24px;
  }
}

.project:nth-child(1) .screenshot {
  background-color: rebeccapurple;
}

.project:nth-child(2) .screenshot {
  background-color: orange;
}

.project:nth-child(3) .screenshot {
  background-color: #008000;
}

.project:nth-child(4) .screenshot {
  background-color: #d64da2;
}

.project:nth-child(5) .screenshot {
  background-color: var(--accent-color);
}

.project:nth-child(6) .screenshot {
  background-color: #016101;
}

/* FOOTER */
footer {
  background-color: rgb(23, 161, 224);
  color: #fff;
  .info {
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    h2 {
      align-self: center;
      margin-bottom: -12px;
    }

    p {
      font-size: 1.1rem;
    }

    .email {
      margin-top: -16px;
    }

    nav {
      align-self: center;

      ul {
        gap: 36px;
      }
    }
  }

  .info > p:first-of-type {
    font-size: 1.4rem;
    font-weight: 500;
  }

  .picture {
    margin-top: 56px;
  }

  .icon {
    display: none;
  }
}

@media (min-width: 650px) {
  body > * {
    padding: 0 48px;
  }

  /* HEADER */
  header {
    display: block;
    padding-top: 40px;

    h2 {
      font-size: 2rem;
      text-align: center;
    }

    p {
      font-size: 1rem;
      margin-left: auto;
      margin-right: auto;
    }

    nav {
      display: none;
    }
  }

  .img-wrapper {
    float: left;
    margin-right: 18px;
    margin-bottom: 0;
    margin: -18px 18px 0 -18px;
    z-index: 10;
    img {
      max-width: 350px;
    }
  }

  .about-me {
    display: block;
    padding: 24px;
    box-shadow: 2px 2px 12px #666;
  }

  /* MAIN */
  main h2 {
    align-self: flex-start;
  }

  .project-container {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 24px;
  }

  .project {
    margin-bottom: 32px;
    max-width: 265px;
    .screenshot {
      font-size: 2.5rem;
    }
  }

  /* FOOTER */
  footer {
    flex-direction: row;
    align-items: flex-start;

    .info {
      gap: 20px;

      p:first-of-type {
        font-size: 1rem;
      }
    }

    .info h2,
    .info nav {
      align-self: flex-start;
    }

    .info nav ul {
      gap: 24px;
    }

    .info nav svg {
      height: 24px;
    }

    .picture {
      margin: 15px 0;
    }

    .icon {
      display: block;
    }

    .phone-number,
    .email {
      display: flex;
      align-items: center;
      gap: 12px;

      svg {
        fill: #fff;
      }
    }
  }
}

@media (min-width: 1000px) {
  header {
    display: flex;
    flex-direction: row;
    padding: 64px 64px 0;
  }

  .img-wrapper {
    transform: scale(1.1);
    margin-right: -18px;
    img {
      max-width: 400px;
    }
  }

  .header-bg {
    clip-path: polygon(0% 0%, 100% 0%, 100% 50%, 0% 100%);
  }

  .about-me {
    padding-left: 64px;

    h2 {
      justify-self: flex-start;
    }

    p {
      margin: 18px 0;
    }

    nav {
      display: block;
      justify-self: flex-end;

      svg {
        height: 28px;
      }
    }
  }

  main section {
    margin-bottom: 56px;
  }

  footer {
    .info {
      padding: 30px 15px;
      gap: 36px;
      margin-right: 24px;
      h2 {
        font-size: 2.5rem;
      }
      p,
      p:first-of-type {
        font-size: 1.4rem;
      }

      nav svg {
        height: 32px;
      }
    }

    .picture {
      margin: 30px 0;
      max-width: 400px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB;;0DAE0D;AAC5D;;AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;;EAEjB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB;IACE,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oDAAoD;EACpD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,+BAA+B;;EAE/B;IACE,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,QAAQ;;IAER;MACE,YAAY;IACd;EACF;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,mCAAmC;EACnC,WAAW;EACX;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET;MACE,kBAAkB;MAClB,oBAAoB;IACtB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;;MAElB;QACE,SAAS;MACX;IACF;EACF;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA,WAAW;EACX;IACE,cAAc;IACd,iBAAiB;;IAEjB;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,WAAW;IACX;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,cAAc;IACd,aAAa;IACb,6BAA6B;EAC/B;;EAEA,SAAS;EACT;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB;MACE,iBAAiB;IACnB;EACF;;EAEA,WAAW;EACX;IACE,mBAAmB;IACnB,uBAAuB;;IAEvB;MACE,SAAS;;MAET;QACE,eAAe;MACjB;IACF;;IAEA;;MAEE,sBAAsB;IACxB;;IAEA;MACE,SAAS;IACX;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,cAAc;IAChB;;IAEA;;MAEE,aAAa;MACb,mBAAmB;MACnB,SAAS;;MAET;QACE,UAAU;MACZ;IACF;EACF;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,kBAAkB;;IAElB;MACE,wBAAwB;IAC1B;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,cAAc;MACd,sBAAsB;;MAEtB;QACE,YAAY;MACd;IACF;EACF;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE;MACE,kBAAkB;MAClB,SAAS;MACT,kBAAkB;MAClB;QACE,iBAAiB;MACnB;MACA;;QAEE,iBAAiB;MACnB;;MAEA;QACE,YAAY;MACd;IACF;;IAEA;MACE,cAAc;MACd,gBAAgB;IAClB;EACF;AACF","sourcesContent":["@font-face {\n  font-family: \"Quicksand\";\n  src:\n    url(\"./Quicksand-VariableFont_wght.woff2\") format(\"woff2\"),\n    url(\"./Quicksand-VariableFont_wght.woff\") format(\"woff\");\n}\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --accent-color: #2da0ff;\n}\n\n/* General styling */\nbody {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n\n  font-family: Quicksand, Arial, Helvetica, sans-serif;\n}\n\nbody > * {\n  width: 100%;\n  max-width: 1600px;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\nheader,\nfooter {\n  flex: 0;\n  height: 72px;\n}\n\nmain {\n  flex: 1;\n}\n\nsection {\n  flex: 1;\n}\n\nimg {\n  display: block;\n  margin: 0 auto;\n  width: 100%;\n  max-width: 600px;\n}\n\nnav ul {\n  display: flex;\n  list-style: none;\n  gap: 24px;\n}\n\nsvg {\n  display: block;\n  fill: #000;\n  height: 36px;\n  cursor: pointer;\n}\n\np {\n  max-width: 60ch;\n}\n\nh2 {\n  font-size: 2.3rem;\n  font-weight: 600;\n}\n\nh3 {\n  font-weight: 500;\n}\n\n/* HEADER */\nheader {\n  position: relative;\n  div {\n    position: relative;\n    z-index: 1;\n  }\n}\n\n.img-wrapper img {\n  max-width: 350px;\n}\n.header-bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  clip-path: polygon(0% 0%, 100% 0%, 100% 25%, 0% 50%);\n  background-color: var(--accent-color);\n}\n\n.about-me {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #fff;\n}\n\nheader p {\n  margin: 8px 0 16px;\n  font-size: 1.2rem;\n}\n\nheader div {\n  position: relative;\n  margin-bottom: 18px;\n  h1 {\n    color: #fff;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: fit-content;\n    font-size: 3rem;\n  }\n}\n\n/* MAIN */\nmain section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 56px 0 112px;\n  h2 {\n    margin-bottom: 24px;\n    font-size: 3rem;\n    font-weight: normal;\n  }\n}\n\n.project-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 56px;\n}\n\n.project {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  height: 450px;\n  max-width: 300px;\n  box-shadow: 4px 4px 5px #d3d3d3;\n\n  .screenshot {\n    height: 275px;\n    color: white;\n    display: flex;\n    align-items: center;\n    font-size: 3rem;\n  }\n\n  .row {\n    width: 100%;\n    display: flex;\n    justify-content: space-around;\n  }\n\n  nav ul {\n    gap: 8px;\n\n    svg {\n      height: 28px;\n    }\n  }\n\n  p {\n    margin: 0 24px;\n  }\n}\n\n.project:nth-child(1) .screenshot {\n  background-color: rebeccapurple;\n}\n\n.project:nth-child(2) .screenshot {\n  background-color: orange;\n}\n\n.project:nth-child(3) .screenshot {\n  background-color: #008000;\n}\n\n.project:nth-child(4) .screenshot {\n  background-color: #d64da2;\n}\n\n.project:nth-child(5) .screenshot {\n  background-color: var(--accent-color);\n}\n\n.project:nth-child(6) .screenshot {\n  background-color: #016101;\n}\n\n/* FOOTER */\nfooter {\n  background-color: rgb(23, 161, 224);\n  color: #fff;\n  .info {\n    padding: 15px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    h2 {\n      align-self: center;\n      margin-bottom: -12px;\n    }\n\n    p {\n      font-size: 1.1rem;\n    }\n\n    .email {\n      margin-top: -16px;\n    }\n\n    nav {\n      align-self: center;\n\n      ul {\n        gap: 36px;\n      }\n    }\n  }\n\n  .info > p:first-of-type {\n    font-size: 1.4rem;\n    font-weight: 500;\n  }\n\n  .picture {\n    margin-top: 56px;\n  }\n\n  .icon {\n    display: none;\n  }\n}\n\n@media (min-width: 650px) {\n  body > * {\n    padding: 0 48px;\n  }\n\n  /* HEADER */\n  header {\n    display: block;\n    padding-top: 40px;\n\n    h2 {\n      font-size: 2rem;\n      text-align: center;\n    }\n\n    p {\n      font-size: 1rem;\n      margin-left: auto;\n      margin-right: auto;\n    }\n\n    nav {\n      display: none;\n    }\n  }\n\n  .img-wrapper {\n    float: left;\n    margin-right: 18px;\n    margin-bottom: 0;\n    margin: -18px 18px 0 -18px;\n    z-index: 10;\n    img {\n      max-width: 350px;\n    }\n  }\n\n  .about-me {\n    display: block;\n    padding: 24px;\n    box-shadow: 2px 2px 12px #666;\n  }\n\n  /* MAIN */\n  main h2 {\n    align-self: flex-start;\n  }\n\n  .project-container {\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 24px;\n  }\n\n  .project {\n    margin-bottom: 32px;\n    max-width: 265px;\n    .screenshot {\n      font-size: 2.5rem;\n    }\n  }\n\n  /* FOOTER */\n  footer {\n    flex-direction: row;\n    align-items: flex-start;\n\n    .info {\n      gap: 20px;\n\n      p:first-of-type {\n        font-size: 1rem;\n      }\n    }\n\n    .info h2,\n    .info nav {\n      align-self: flex-start;\n    }\n\n    .info nav ul {\n      gap: 24px;\n    }\n\n    .info nav svg {\n      height: 24px;\n    }\n\n    .picture {\n      margin: 15px 0;\n    }\n\n    .icon {\n      display: block;\n    }\n\n    .phone-number,\n    .email {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n\n      svg {\n        fill: #fff;\n      }\n    }\n  }\n}\n\n@media (min-width: 1000px) {\n  header {\n    display: flex;\n    flex-direction: row;\n    padding: 64px 64px 0;\n  }\n\n  .img-wrapper {\n    transform: scale(1.1);\n    margin-right: -18px;\n    img {\n      max-width: 400px;\n    }\n  }\n\n  .header-bg {\n    clip-path: polygon(0% 0%, 100% 0%, 100% 50%, 0% 100%);\n  }\n\n  .about-me {\n    padding-left: 64px;\n\n    h2 {\n      justify-self: flex-start;\n    }\n\n    p {\n      margin: 18px 0;\n    }\n\n    nav {\n      display: block;\n      justify-self: flex-end;\n\n      svg {\n        height: 28px;\n      }\n    }\n  }\n\n  main section {\n    margin-bottom: 56px;\n  }\n\n  footer {\n    .info {\n      padding: 30px 15px;\n      gap: 36px;\n      margin-right: 24px;\n      h2 {\n        font-size: 2.5rem;\n      }\n      p,\n      p:first-of-type {\n        font-size: 1.4rem;\n      }\n\n      nav svg {\n        height: 32px;\n      }\n    }\n\n    .picture {\n      margin: 30px 0;\n      max-width: 400px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
